import Muted from '@/assets/images/actionToolbar/muted.svg';
import Unmuted from '@/assets/images/actionToolbar/unmuted.svg';
import styles from './volumeToggle.module.scss';
import useAudioStore from '@/stores/audio';

export default function VolumeToggle() {
  const { isMuted, toggleMute } = useAudioStore();
  return (
    <button className={styles.volumeToggle} onClick={toggleMute}>
      {isMuted ? <Muted /> : <Unmuted />}
    </button>
  );
}
